// extracted by mini-css-extract-plugin
export default {"theme":"prism-module--theme--cn1ZL text-monospace","dark":"prism-module--dark--L_BTN","light":"prism-module--light--S16oB"};